<template>
  <AttachmentBalloon
    :date="date"
    :userType="userType"
    :hasBeenRead="hasBeenRead"
  >
    {{ timeslotLabel }}
  </AttachmentBalloon>
</template>

<script setup lang="ts">
import AttachmentBalloon from '@/components/organisms/ChatMessageList/AttachmentBalloon.vue'
import { type ChatMessageUserType } from '@/components/organisms/ChatMessageList/ChatMessageUserType'
import { type Attachment } from '@/types/app'
import { format } from 'date-fns'
import { computed } from 'vue'

const p = defineProps<{
  date: Date
  userType: ChatMessageUserType
  hasBeenRead: boolean
  attachment: Attachment & { type: 'bookingAnswer' }
}>()

const timeslotLabel = computed(
  () =>
    `${format(p.attachment.content.startsAt, 'yyyy/MM/dd')} ${format(
      p.attachment.content.startsAt,
      'HH:mm'
    )} ~ ${format(p.attachment.content.endsAt, 'HH:mm')}`
)
</script>
